// @flow

import React, { type Element } from 'react'
import { Box, Grid } from '@material-ui/core'
import type { Diagnosis } from '../../types'

type Props = {|
  option: Diagnosis,
|}

function DiagnosisOption({ option }: Props): Element<typeof React.Fragment> {
  return (
    <Grid item xs={12}>
      <Grid container direction="row" justify="space-between">
        <span>{option.group}</span>
        <Box component="span" fontWeight="fontWeightBold">
          {option.code}
        </Box>
      </Grid>
      <Grid container direction="row">
        <Box pl={2}>{option.sub_group}</Box>
      </Grid>
      <Box pl={4} fontWeight="fontWeightBold">
        {option.title}
      </Box>
    </Grid>
  )
}

export default DiagnosisOption
